import {
    primaryColor,
    warningColor,
    dangerColor,
    successColor,
    infoColor,
    roseColor,
    grayColor,
    title,
} from "../../../../assets/jss/material-kit-react.jsx"

const infoStyle = {
    infoArea: {
        maxWidth: "500px",
        margin: "0 auto",
        padding: "0px",
        textAlign: "left",
    },
    iconWrapper: {
        float: "left",
        marginTop: "24px",
        marginRight: "10px",
    },
    primary: {
        color: primaryColor,
    },
    warning: {
        color: warningColor,
    },
    danger: {
        color: dangerColor,
    },
    success: {
        color: successColor,
    },
    info: {
        color: infoColor,
    },
    rose: {
        color: roseColor,
    },
    gray: {
        color: grayColor,
    },
    icon: {
        width: "66px",
        height: "66px",
    },
    descriptionWrapper: {
        color: grayColor,
        paddingLeft: "2rem",
        paddingRight: "2rem",
        overflow: "hidden",
    },
    title: {
        ...title,
        fontSize: "1.3rem",
        marginTop: "1.2rem",
        marginBottom: "1.2rem",
        color: "rgb(34, 36, 37)",
    },
    description: {
        color: "#3C4858",
        overflow: "hidden",
        marginTop: "0px",
        fontSize: "14px",
        fontWeight: "400",
    },
    iconWrapperVertical: {
        float: "none",
    },
    iconVertical: {
        color: "rgb(60, 72, 88)",
        width: "66px",
        height: "66px",
    },
}

export default infoStyle



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-react/components/infoStyle.jsx